import { tmCTMTContract } from "./ConAddsAndABIs"
import React, { useEffect, useState } from "react";
import MyManagersTable from "./MyManagersTable";

function SellectTFT(){

    let cTFTButton = [];
    const arrTFTId = ['0', '1', '2', '3']
    const arrTFTname = ['btc', 'eth', 'wbnb', 'monsta']
    const arrTFTAddress = ['0x7130d2A12B9BCbFAe4f2634d864A1Ee1Ce3Ead9c', '0x2170Ed0880ac9A755fd29B2688956BD959F933F8', 
                           '0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c', '0xad6f51E9794d41d3f1755C21DdaB9Fda7387F1e9']

    for (let i=0; i < arrTFTId.length; i++) {

      const ata = arrTFTAddress[i]
      const ataF = ata.toString()
      
      const chooseTFT = async (e) => {
        e.preventDefault();
        const txn = await tmCTMTContract.chooseTokenToTrade(ataF)
        await txn.wait();
        }                  
      
      const chooseTFTB = <button onClick={chooseTFT}>Choose</button> 
        cTFTButton.push(chooseTFTB)

      }


    let currentTFTData = []                    
    let tftData = arrTFTId.map((id, index) => {
    const tftObject = {};
      tftObject.id = id;
      tftObject.name = arrTFTname[index];
      tftObject.sellectB = cTFTButton[index];
      tftObject.add = arrTFTAddress[index];

      return tftObject;
    })

    currentTFTData = tftData
    const column = [
      {heading: 'Id', value: 'id'},
      {heading: 'Name', value: 'name'},
      {heading: 'Choose', value: 'sellectB'},
      {heading: 'Token Address', value: 'add'},
    ]

const [sellectedTFT, setSellectedTFT] = useState("");

const [tokenId, setTokenId] = useState([]);
const [tokenName, setTokenName] = useState([]);
const [sellectTFTButton, setSellectTFTButton] = useState([]);
const [tokenAddress, setTokenAddress] = useState([]);
const [tokenForTrading, setTokenForTrading] = useState([]);

let thisData = []

let tokenForTradingData = tokenId.map((id, index) => {
  const tftObject = {};
  tftObject.id = id;
  tftObject.name = tokenName[index]
  tftObject.sellectB = sellectTFTButton[index]
  tftObject.add = tokenAddress[index]
  tftObject.tftft = tokenForTrading[index]

  return tftObject;
})

let filteredTft = tokenForTradingData.filter((tft) => tft.tftft === 'true')
thisData = filteredTft

const tftcolumn = [
  {heading: 'Id', value: 'id'},
  {heading: 'Token', value: 'name'},
  {heading: 'Choose', value: 'sellectB'},
  {heading: 'Address', value: 'add'},
  //{heading: 'For Trading', value: 'tftft'},
]

useEffect(() => {  
        
  const getTFT = async () => {
      const accounts = await window.ethereum.request({method: "eth_requestAccounts",});
      const sellectedTFT = await tmCTMTContract.alreadySellectedTFT(accounts[0])
      const sellectedTFTF = sellectedTFT.toString()
        setSellectedTFT(sellectedTFTF) 
      }

  getTFT()
      .catch(console.error)              

  const createFTFDetails = async () => {
    const tftCount = await tmCTMTContract.tokenForTradingCount()
    let tokId = [];
    let tokName = [];
    let tokSellectButton = [];
    let tokAdd = [];
    let tokTFTFT = [];    

    async function handleTFTData() {
      for (let i=0; i < tftCount; i++) {
        const tName = await tmCTMTContract.tokenName(i)

        const chooseTFT = async (e) => {
          e.preventDefault();
          const txn = await tmCTMTContract.chooseTokenToTrade(i)
          await txn.wait();
          }                  
        
        const chooseTFTB = <button onClick={chooseTFT}>Choose</button> 

        const tAdd = await tmCTMTContract.tftAdd(i)
        const tAddF = tAdd.toString()
        
        const tFT = await tmCTMTContract.isThisTokenAFTrading(i)
        const tFTF = tFT.toString()
        
        tokId.push(i)
        tokName.push(tName)
        tokSellectButton.push(chooseTFTB)
        tokAdd.push(tAddF)
        tokTFTFT.push(tFTF)

      }
      setTokenId(tokId)
      setTokenName(tokName)
      setSellectTFTButton(tokSellectButton)
      setTokenAddress(tokAdd)
      setTokenForTrading(tokTFTFT)
    
    }    
    handleTFTData();
    return(null);
    }

  createFTFDetails()
      .catch(console.error)     




})


if (sellectedTFT === 'true') 
  {return(
    <div>
          <MyManagersTable />
    </div>
  )}

  else {
      return ( 
        <div>
              <div>
              <h3 style={{"textAlign": "center"}}>Sellect Token To Trade</h3>
              </div>
        <table className="manTable" >
          <colgroup>
    
    
          </colgroup>
          <thead>
              <tr>
                {tftcolumn.map((item, index) => <th key={index} >{item.heading}</th>) }
              </tr>
          </thead>
          <tbody>
              {filteredTft.map((item, index) => (
                  <tr key={index}>
                    {tftcolumn.map((columnItem, index) => {
                      return<td key={index} >{item[`${columnItem.value}`]} </td>
                    })}
                  </tr>
                )) }                                                                                    
          </tbody>
        </table>  
        </div>
    )
  }

 

}


export default SellectTFT;